/* ============================================================
   AI CHAT WIDGET — ai-chat.js
   Agente IA de recomendación de muebles para Decasa.
   Prefijo: ac-  |  Sin dependencias externas.
   ============================================================ */

(function () {
  'use strict';

  var cfg       = window._AC_CONFIG || {};
  var API_URL   = cfg.apiUrl    || '';
  var WA_NUMBER = cfg.whatsapp  || '573148622755';
  var STORAGE_KEY = 'ac_history';
  var MAX_HISTORY = 10;

  var WELCOME_MSG = '¡Hola! Soy el asesor virtual de Decasa 👋\n¿En qué te puedo ayudar hoy? Puedes preguntarme cosas como:\n• "Busco una cama moderna"\n• "Necesito un sofá para sala pequeña"\n• "¿Qué comedores tienen en madera?"';

  var ICON_SEND =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M22 2 11 13M22 2 15 22 11 13 2 9l20-7z"/>'
    + '</svg>';

  var ICON_CLOSE =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">'
    + '<path d="M18 6 6 18M6 6l12 12"/>'
    + '</svg>';

  var ICON_BOT =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">'
    + '<rect x="3" y="11" width="18" height="11" rx="2"/>'
    + '<path d="M12 2a3 3 0 0 1 3 3v6H9V5a3 3 0 0 1 3-3z"/>'
    + '<line x1="8" y1="16" x2="8" y2="16"/><line x1="16" y1="16" x2="16" y2="16"/>'
    + '<line x1="12" y1="2" x2="12" y2="2"/>'
    + '</svg>';

  var ICON_GRID =
    '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>'
    + '<rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>'
    + '</svg>';

  var ICON_WA =
    '<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">'
    + '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>'
    + '</svg>';

  /* ── Estado ─────────────────────────────────────────────── */

  var state = {
    open:    false,
    loading: false,
    history: []
  };

  /* ── DOM refs ────────────────────────────────────────────── */

  var el = {};

  /* ── Init ────────────────────────────────────────────────── */

  function init() {
    el.trigger  = document.getElementById('ac-trigger');
    el.panel    = document.getElementById('ac-panel');
    el.messages = document.getElementById('ac-messages');
    el.input    = document.getElementById('ac-input');
    el.sendBtn  = document.getElementById('ac-send-btn');
    el.closeBtn = document.getElementById('ac-close-btn');

    if (!el.panel) return;

    state.history = loadHistory();

    el.trigger && el.trigger.addEventListener('click', openChat);
    el.closeBtn && el.closeBtn.addEventListener('click', closeChat);
    el.sendBtn  && el.sendBtn.addEventListener('click', sendMessage);

    el.input && el.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendMessage();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) closeChat();
    });

    // Mostrar historial previo o mensaje de bienvenida
    if (state.history.length > 0) {
      renderHistory();
    } else {
      appendBubble('ai', WELCOME_MSG);
    }
  }

  /* ── Abrir / Cerrar ──────────────────────────────────────── */

  function openChat() {
    if (state.open) return;
    state.open = true;
    el.panel.classList.add('ac-open');
    el.input && el.input.focus();
    scrollToBottom();
  }

  function closeChat() {
    if (!state.open) return;
    state.open = false;
    el.panel.classList.remove('ac-open');
    el.trigger && el.trigger.focus();
  }

  /* ── Enviar mensaje ──────────────────────────────────────── */

  function sendMessage() {
    if (state.loading || !el.input) return;
    var text = el.input.value.trim();
    if (!text) return;

    el.input.value = '';
    appendBubble('user', text);

    if (!API_URL) {
      appendBubble('ai', 'El asesor IA estará disponible muy pronto. Por ahora puedes explorar el catálogo completo con el botón "Ver catálogo" o escribirnos por WhatsApp.');
      return;
    }

    state.loading = true;
    setInputEnabled(false);
    var typingEl = appendTyping();

    callAPI(text, state.history)
      .then(function (data) {
        removeTyping(typingEl);
        appendBubble('ai', data.reply, data.products || [], data.showCatalogBtn);
        state.history.push({ role: 'user', content: text });
        state.history.push({ role: 'assistant', content: data.reply });
        if (state.history.length > MAX_HISTORY) {
          state.history = state.history.slice(-MAX_HISTORY);
        }
        saveHistory(state.history);
      })
      .catch(function () {
        removeTyping(typingEl);
        appendBubble('ai', 'Hubo un problema al conectar con el asesor. Intenta de nuevo o escríbenos directamente por WhatsApp.');
      })
      .finally(function () {
        state.loading = false;
        setInputEnabled(true);
        el.input && el.input.focus();
      });
  }

  /* ── Llamada a la API ────────────────────────────────────── */

  function callAPI(message, history) {
    return fetch(API_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ message: message, history: history })
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  /* ── Render de mensajes ──────────────────────────────────── */

  function appendBubble(role, text, products, showCatalogBtn) {
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'display:flex;flex-direction:column;gap:0.5rem;';

    var bubble = document.createElement('div');
    bubble.className = 'ac-bubble ac-bubble--' + role;
    bubble.textContent = text;
    wrapper.appendChild(bubble);

    if (products && products.length > 0) {
      wrapper.appendChild(renderCards(products));
    }

    if (showCatalogBtn && role === 'ai') {
      var btn = document.createElement('button');
      btn.className = 'ac-catalog-btn';
      btn.innerHTML = ICON_GRID + ' Ver catálogo completo';
      btn.addEventListener('click', function () {
        if (window.MCatalogo && window.MCatalogo.open) {
          window.MCatalogo.open();
        }
      });
      wrapper.appendChild(btn);
    }

    el.messages.appendChild(wrapper);
    scrollToBottom();
    return wrapper;
  }

  function appendTyping() {
    var el_typing = document.createElement('div');
    el_typing.className = 'ac-typing';
    el_typing.innerHTML = '<span></span><span></span><span></span>';
    el.messages.appendChild(el_typing);
    scrollToBottom();
    return el_typing;
  }

  function removeTyping(el_typing) {
    if (el_typing && el_typing.parentNode) {
      el_typing.parentNode.removeChild(el_typing);
    }
  }

  /* ── Cards de productos ──────────────────────────────────── */

  function renderCards(products) {
    var container = document.createElement('div');
    container.className = 'ac-cards';

    products.forEach(function (p) {
      var card = document.createElement('div');
      card.className = 'ac-card';

      var imgHtml = p.image
        ? '<img class="ac-card__img" src="' + _esc(p.image) + '" alt="' + _esc(p.name) + '" loading="lazy" decoding="async">'
        : '<div class="ac-card__img-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="m3 9 4-4 4 4 4-5 6 7"/></svg></div>';

      var btnHtml;
      if (p.buyMode === 'shopify' && p.handle) {
        var productUrl = '/products/' + _esc(p.handle);
        btnHtml = '<a href="' + productUrl + '" class="ac-card__shop">Ver producto</a>';
      } else {
        var waText = encodeURIComponent('Estoy interesado en ' + p.name);
        var waUrl  = 'https://wa.me/' + WA_NUMBER + '?text=' + waText;
        btnHtml = '<a href="' + waUrl + '" target="_blank" rel="noopener noreferrer" class="ac-card__wa">' + ICON_WA + ' WhatsApp</a>';
      }

      card.innerHTML = imgHtml
        + '<div class="ac-card__body">'
        + '<span class="ac-card__cat">' + _esc(p.categoryLabel || p.category) + '</span>'
        + '<p class="ac-card__name">'   + _esc(p.name) + '</p>'
        + btnHtml
        + '</div>';

      container.appendChild(card);
    });

    return container;
  }

  /* ── Historial ───────────────────────────────────────────── */

  function renderHistory() {
    state.history.forEach(function (msg) {
      var bubble = document.createElement('div');
      bubble.className = 'ac-bubble ac-bubble--' + (msg.role === 'user' ? 'user' : 'ai');
      bubble.textContent = msg.content;
      el.messages.appendChild(bubble);
    });
    scrollToBottom();
  }

  function saveHistory(history) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(history)); } catch (e) {}
  }

  function loadHistory() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  /* ── Utilidades ──────────────────────────────────────────── */

  function scrollToBottom() {
    if (el.messages) {
      requestAnimationFrame(function () {
        el.messages.scrollTop = el.messages.scrollHeight;
      });
    }
  }

  function setInputEnabled(enabled) {
    if (el.input)   el.input.disabled   = !enabled;
    if (el.sendBtn) el.sendBtn.disabled = !enabled;
  }

  function _esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;');
  }

  /* ── Arranque ────────────────────────────────────────────── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
